import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiGet } from '@/shared/utils/requestBuilder';
import type { PendenciasResponse } from '@/types/pendencias/pendenciasTypes';

export const fetchPendencias = createAsyncThunk<PendenciasResponse>(
  'pendencias/fetchPendencias',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiGet('/pendencias');

      if (!response.ok) throw new Error('Erro ao buscar pendências');

      const json = await response.json();
      const data = (json as { data?: PendenciasResponse }).data ?? (json as PendenciasResponse);

      return data;
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
